import { render, staticRenderFns } from "./ProductModifyPromotionPopupIframe.vue?vue&type=template&id=46989c5c&"
import script from "./ProductModifyPromotionPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductModifyPromotionPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports